import { IApplicationState } from '../types/redux';
import { ISpecificationItem } from '../types/newbuilding/specification';

export const specificationsSelector = (state: IApplicationState): ISpecificationItem[] => {
  return state.newbuilding.specifications;
};
